import Reveal from "@/components/Reveal";
import PlantMap from "@/components/marketing/PlantMap";
import { PLANTS } from "@/data/content";
import { Factory, Phone } from "lucide-react";
import { trackEvent } from "@/lib/tracking";

export default function Asphalt() {
  return (
    <section id="asphalt" data-testid="asphalt-section" className="bg-rc-bg py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <Reveal trackLabel="asphalt">
            <div className="font-mono text-rc-red text-xs uppercase tracking-[0.3em] mb-5">05 — FOB Asphalt Sales</div>
            <h2 className="font-heading font-black text-rc-blue leading-[0.95] text-[clamp(2rem,4.5vw,3.5rem)] tracking-tight">
              High-quality asphalt, four Florida plants.
            </h2>
            <p className="mt-6 text-rc-brown text-lg leading-relaxed">
              Ranger provides the highest quality FOB asphalt products on all our jobs and to all our customers. Pick up
              from the plant nearest your job location.
            </p>
          </Reveal>

          <div className="mt-8 grid sm:grid-cols-2 gap-px bg-black/10 border border-black/10">
            {PLANTS.map((p) => (
              <div
                key={p.city}
                data-testid={`plant-${p.city.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="bg-white p-5 hover:bg-rc-red/5 transition-colors"
              >
                <div className="flex items-center gap-2 font-heading font-bold text-rc-charcoal">
                  <Factory size={16} className="text-rc-red" /> {p.city}
                </div>
                <div className="text-rc-brown text-xs mt-2 leading-relaxed">{p.address}</div>
                <a
                  href={`tel:${p.phone.replace(/\./g, "")}`}
                  onClick={() => trackEvent("cta_click", { label: `plant_call_${p.city}` })}
                  className="mt-2 inline-flex items-center gap-1.5 font-mono text-rc-red text-xs hover:text-rc-reddark"
                >
                  <Phone size={11} /> {p.phone}
                </a>
              </div>
            ))}
          </div>
        </div>

        <Reveal delay={0.1} className="overflow-hidden rounded-2xl border border-black/10 shadow-sm">
          <PlantMap />
        </Reveal>
      </div>
    </section>
  );
}
